import { useContext } from "react"
import { Context } from "../context/FirestoreContext"

import Cards from "../components/Cards"
import "./App.css"
export default function App() {
  const { state } = useContext(Context)  
  return (
    <>
      <h1 className="text-center">All Comments</h1>
      <p className="text-center">
        There {state.items.length > 1 ? 'are' : 'is'} {state.items.length} comment{state.items.length > 1 ? 's' : ''}
      </p>
      <Cards items={state.items} />
    </>
  )
}